export enum CumulativeTypes{
    OCCURENCE='OCCURENCE',
    VALUE='VALUE'
}